import { Box, Typography } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { AUTOMATIONS_LAYOUT_MAX_WIDTH } from '../../Automations/helper';
import { useGetSidePadding } from '../configuration-canvas-panel/useGetSidePadding';
import { PAGE_SIDE_PADDING } from '../../../constants';

export const PageTemplates = ({
  title,
  isFullPage,
  children,
}: {
  title: string;
  isFullPage: boolean;
  children: React.ReactNode;
}) => {
  const sidePadding = useGetSidePadding();
  const fullPageSx = {
    width: '100%',
    height: '100vh',
    position: 'fixed',
    background: 'white',
    zIndex: '100',
    p: `72px ${PAGE_SIDE_PADDING}px`,
    top: '56px',
    left: 0,
    overflow: 'scroll',
    display: 'flex',
    justifyContent: 'center',
  };

  const boxSx = {
    padding: `32px ${sidePadding}px`,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'auto',
  };
  return (
    <Box sx={isFullPage ? fullPageSx : boxSx}>
      <Box
        sx={{
          minWidth: '800px',
          maxWidth: AUTOMATIONS_LAYOUT_MAX_WIDTH,
          width: AUTOMATIONS_LAYOUT_MAX_WIDTH,
        }}
      >
        <Typography variant="h2">{title}</Typography>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body" color={colors.grey[800]}>
            Build it now and deploy whenever you're ready
          </Typography>
        </Box>

        <Box sx={{ mt: '48px', overflow: 'scroll' }}>{children}</Box>
      </Box>
    </Box>
  );
};
